<template>
  <div>
    <el-card class="box-card">
      <el-form ref="searchForm" :model="searchForm" :label-width="formLabelWidth" :inline="true">
        <el-form-item label="名字" prop="name">
          <el-input v-model="searchForm.search_content" placeholder="请输入直播名字" auto-complete="off" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button :size="buttonSize" type="primary" @click="pageList" icon="el-icon-search">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <el-card class="box-card" style="margin-top: 20px;">
      <el-table
        ref="multipleTable"
        :data="page.rows"
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        tooltip-effect="dark"
        style="margin-top: 20px; width: 100%;"
        border
        @selection-change="selectionChange"
      >
        <el-table-column prop="imgUrl" label="封面">
          <template slot-scope="scope">
            <img
              width="200px"
              height="80px"
              :src="scope.row.imgUrl"
            />
          </template>
        </el-table-column>
        <el-table-column prop="title" label="名字" width="150"   :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="aliveStartAt" label="开始时间"></el-table-column>
        <el-table-column prop="aliveStopAt" label="结束时间"></el-table-column>
        <el-table-column prop="aliveType" label="直播类型">
          <template slot-scope="scope">
            <span v-if="scope.row.aliveType === 10">横屏直播</span>
            <span v-if="scope.row.aliveType === 11">竖屏直播</span>
            <span v-if="scope.row.aliveType === 12">语音直播</span>
            <span v-if="scope.row.aliveType === 13">录播直播</span>
          </template>
        </el-table-column>
        <el-table-column prop="aliveState" label="直播状态">
          <template slot-scope="scope">
            <span v-if="scope.row.aliveState === 0">未开始</span>
            <span v-if="scope.row.aliveState === 1">直播中</span>
            <span v-if="scope.row.aliveState === 2">已结束</span>
          </template>
        </el-table-column>
        <el-table-column prop="liveStreamingParam" label="串流码" width="100"  :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="hasFree" label="是否免费" width="50">
          <template slot-scope="scope">
            <span v-if="scope.row.hasFree === -1">收费</span>
            <span v-if="scope.row.hasFree === 1">免费</span>
          </template>
        </el-table-column>

        <el-table-column prop="replayNumber" label="单节点回放/层级回访"  width="100" align="center">
          <template slot-scope="scope">
            <span class="mainColor" @click="goUploadPage(scope.row)">{{ scope.row.videoCount || 0 }} / {{ scope.row.subjectVideoCount || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          width="100"
          :show-overflow-tooltip="true"
          align="center"
          prop="videoCount"
          label="单节点资料/层级资料"
        >
          <template slot-scope="scope">
            <span class="mainColor" @click="opMaterials(scope.row)"
            >{{ scope.row.materialCount }}/{{
                scope.row.materialsCount
              }}</span
            >
          </template>
        </el-table-column>
        <el-table-column prop label="操作" width="80">
          <template slot-scope="scope">
            <span class="mainColor" @click="changeEditFormVisible(scope.row)">编辑</span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total, prev, pager, next"
        style="margin-top: 20px;text-align: right;"
        :total="page.total"
        :page-size="page.pageSize"
        :current-page="page.pageNumber"
        @size-change="sizeChange"
        @current-change="currentChange"
      ></el-pagination>
    </el-card>

    <el-dialog
      title="编辑"
      :visible.sync="editFormVisible"
      width="400px"
      left>
      <el-form
        ref="agentTouristInfo"
        :model="xiaoETongInfo"
        :label-width="formLabelWidth">

        <el-col :sm="50" :md="50" :lg="50">
          <p style="padding-left: 30px">串流码实例：5060_ZrtaYHtbGS6DYTFs.m3u8</p>
          <p style="padding-left: 30px">注意：.m3u8若未填写将自动补全</p>
          <el-form-item label="串流码">
            <el-input
              type="textarea"
              v-model="xiaoETongInfo.liveStreamingParam"
              placeholder="输入串流码"
              auto-complete="off"
              maxlength="100"
            ></el-input>
          </el-form-item>
          <el-form-item label="是否免费">
            <!-- <el-radio v-model="searchForm.sell" label="1">上架</el-radio>
            <el-radio v-model="searchForm.sell" label="0">下架</el-radio>-->
            <el-select v-model="xiaoETongInfo.hasFree" style="width:100%">
              <el-option label="收费" :value= "-1" ></el-option>
              <el-option label="免费" :value= "1"></el-option>
            </el-select>
          </el-form-item>

        </el-col>
      </el-form>
      <div slot="footer" class="dialog-footer" style="text-align: right">
        <el-button @click="editFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="update">确 定</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
export default {
  name: "xiaoETongLiveInfo",
  data() {
    return {
      loading: false,
      dialogWidth:
        document.body.clientWidth <= 1366
          ? "55%"
          : document.body.clientWidth > 1366 &&
          document.body.clientWidth <= 1920
          ? "45%"
          : "40%",
      page: {
        rows: [],
        total: 0,
        pageSize: 10,
        pageNumber: 1,
        sortName: "id",
        sortOrder: "asc"
      },
      addFormVisible: false,
      editFormVisible: false,
      importFormVisible: false,
      searchForm: {
        search_content: "",
      },
      formLabelWidth: "80px",
      selection: "",
      multipleSelection: "",
      ids: [],
      buttonSize: document.body.clientWidth < 992 ? "mini" : "",
      xiaoETongInfo: {},
    }
  },
  methods: {
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.pageList();
    },
    currentChange(pageNumber) {
      this.page.pageNumber = pageNumber;
      this.pageList();
    },
    selectionChange(val) {
      this.multipleSelection = val;
      val.map(e => this.ids.push({ id: e.id }));
    },
    pageList() {
      this.loading = true;
      this.searchForm.page_size = this.page.pageSize;
      this.searchForm.page = this.page.pageNumber;
      if(this.searchForm.page_size >50){
        this.$message.error("每页最大数量50条!");
      }
      this.api.xiaoETongLiveInfo.pageList(this.searchForm).then(result => {
        this.loading = false;
        this.page.rows = result.data.data.list;
        this.page.total = result.data.data.total;
      }).catch(error => {
        console.log(error);
      });
    },
    goUploadPage(row) {
      this.$router.push({
        path: "/checkVideo",
        query: { id: row.newId, name: '录播' },
      });
    },
    opMaterials (row) {
      this.$router.push({
        path: "/checkMaterial",
        query: { id: row.newId, name: '录播' },
      });
    },
    changeEditFormVisible(info) {
      this.xiaoETongInfo = info;
      this.editFormVisible = true;
    },
    update() {
      this.api.xiaoETongLiveInfo.updateXiaoETongLiveInfo(this.xiaoETongInfo).then(res => {
        if(res.success) {
          this.editFormVisible = false;
          this.pageList();
          this.$message.success(res.message);
        } else {
          this.$message.success(res.message);
        }
      })
    },
  },
  watch: {

  },
  mounted() {
    this.pageList();
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/xiaoETongLiveInfo/index.vue